/* lola lane: desktop gallery = horizontal snap track + thumbnail rail (left on wide screens).
   Thumb clicks set scrollLeft directly: scroll-snap cancels smooth scrollTo mid-animation. */
(function(){
  function init(){
    var gal=document.querySelector('.product-information media-gallery')||document.querySelector('media-gallery');
    if(!gal||gal.dataset.pdGal)return;
    var track=gal.querySelector('.media-gallery__grid');
    if(!track)return;
    var slides=[].slice.call(track.children).filter(function(n){return n.tagName==='LI';});
    if(slides.length<2)return;
    gal.dataset.pdGal='1';gal.classList.add('pd-gal');
    var bar=document.createElement('div');bar.className='pd pd-thumbs';
    slides.forEach(function(s,i){
      var img=s.querySelector('img');
      var b=document.createElement('button');b.type='button';
      b.setAttribute('aria-label','Show image '+(i+1)+' of '+slides.length);
      if(img){var t=document.createElement('img');t.src=(img.currentSrc||img.src);t.alt='';t.loading='lazy';b.appendChild(t);}
      b.addEventListener('click',function(){track.scrollLeft=s.offsetLeft-slides[0].offsetLeft;sync();});
      bar.appendChild(b);
    });
    gal.appendChild(bar);
    function sync(){
      var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
      [].forEach.call(bar.children,function(b,n){b.classList.toggle('is-on',n===i);});
    }
    track.addEventListener('scroll',sync,{passive:true});sync();
    /* when a colour is picked, Horizon reorders media; jump to the first slide */
    document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-picker')){setTimeout(function(){track.scrollLeft=0;sync();},120);}},true);
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  setTimeout(init,900);setTimeout(init,2500);
})();
